module.exports = __webpack_public_path__ + "static/media/form-builder-main.2409aab4.png";